import { render, staticRenderFns } from "./CheckWhite.vue?vue&type=template&id=3445b2b6&scoped=true"
import script from "./CheckWhite.vue?vue&type=script&lang=js"
export * from "./CheckWhite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445b2b6",
  null
  
)

export default component.exports